export default function Discover() {
  return <div>Hello this is discover!</div>;
}
